import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export interface BulkRecreateGroup {
  propertyId: string;
  roomTypeId: string;
  surchargeType?: string;
  toDelete: Array<string>;
  toCreate: Array<Record<string, unknown>>;
}

export function useBulkRecreateSurchargeDateBlocks() {
  return useMutation({
    mutationFn: async (groups: Array<BulkRecreateGroup>) => {
      for (const group of groups) {
        await ReservationService.bulkRecreateSurchargeDateBlocks(group.propertyId, group.roomTypeId, {
          surcharge_type: group.surchargeType ?? 'vendor',
          to_delete: group.toDelete,
          to_create: group.toCreate,
        });
      }
    },
  });
}
